export type ChatbotTab = 'config' | 'usage' | 'conversations';

export const chatbotFade = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.25, ease: 'easeOut' },
} as const;

export function formatChatbotDate(value: number | Date | null | undefined) {
  if (!value) return 'Sin fecha';
  const date = typeof value === 'number' ? new Date(value * 1000) : new Date(value);
  return date.toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' });
}
